const i18n = {
  'en-US': {
    'menu.exception': 'Exception page',
    'menu.exception.500': '500',
    'exception.result.500.description': 'Internal server error',
    'exception.result.500.back': 'Back'
  },
  'zh-CN': {
    'menu.exception': '异常页',
    'menu.exception.500': '500',
    'exception.result.500.description': '抱歉，服务器出了点问题～',
    'exception.result.500.back': '返回'
  }
};
export default i18n;